export const EXTRAS_COPY =
  'Get help with the cost of things like routine dental check-ups, optical, physio, and other included services.';
export const HOSPITAL_COPY =
  "Get help with the cost of included hospital treatments (e.g. doctor's fees, accommodation, intensive care) when you’re admitted to hospital as a private patient.";
